import { ApplicationInsights } from "@microsoft/applicationinsights-web";

declare global {
    interface Window {
        __appInsightsKey?: string;
    }
}

export function registerAppInsights() {
    if (!window.__appInsightsKey) {
        console.error("Application insights key not provided.");
        return;
    }
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: window?.__appInsightsKey,
            isCookieUseDisabled: true
        },
    });
    delete window.__appInsightsKey;
    appInsights.loadAppInsights();
}
